import React, { useState } from 'react';
import styled from 'styled-components';
import { Section, Container, BlockTitle, t } from '../styles/shared';

const Wrap = styled.div` max-width: 800px; margin: 0 auto; `;

const List = styled.div`
  display: flex; flex-direction: column;
  gap: ${({ $style }) => $style === 'minimal' ? '0' : '12px'};
`;

const Item = styled.div`
  border-radius: ${({ $style }) => $style === 'minimal' ? '0' : '8px'};
  overflow: hidden;
  ${({ $style }) => $style === 'bordered' && `border: 1px solid ${t.border};`}
  ${({ $style }) => $style === 'minimal' && `border-bottom: 1px solid ${t.border};`}
  ${({ $style }) => $style === 'cards' && `box-shadow: 0 2px 8px rgba(0,0,0,0.08);`}
`;

const Question = styled.button`
  display: flex; align-items: center; justify-content: space-between;
  width: 100%; padding: 20px 24px; background: none; border: none;
  cursor: pointer; text-align: left; font-family: ${t.fontBody};
  font-size: 1.125rem; font-weight: 600; color: ${t.text};
  transition: background-color 0.2s;
  &:hover { background-color: ${t.bgAlt}; }
`;

const Icon = styled.span`
  font-size: 1.5rem; font-weight: 300; color: ${t.primary};
  flex-shrink: 0; margin-left: 16px;
`;

const Answer = styled.div`
  max-height: ${({ $open }) => $open ? '2000px' : '0'};
  overflow: hidden; transition: max-height 0.3s ease-out;
`;

const AnswerContent = styled.div`
  padding: 0 24px 24px; color: ${t.textLight};
  p { margin: 0 0 1em 0; &:last-child { margin-bottom: 0; } }
`;

const FAQBlock = ({ content = {}, settings = {} }) => {
  const { title = '', items = [], allowMultiple = false, style = 'bordered' } = content;
  const { backgroundColor = '', padding = 'large' } = settings;
  const [open, setOpen] = useState([]);

  const toggle = (i) => {
    if (allowMultiple) {
      setOpen(prev => prev.includes(i) ? prev.filter(x => x !== i) : [...prev, i]);
    } else {
      setOpen(prev => prev.includes(i) ? [] : [i]);
    }
  };

  return (
    <Section $padding={padding} $bgColor={backgroundColor}>
      <Container>
        <Wrap>
          {title && <BlockTitle>{title}</BlockTitle>}
          <List $style={style}>
            {items.map((item, i) => (
              <Item key={i} $style={style}>
                <Question onClick={() => toggle(i)} aria-expanded={open.includes(i)}>
                  <span>{item.question}</span>
                  <Icon>{open.includes(i) ? '−' : '+'}</Icon>
                </Question>
                <Answer $open={open.includes(i)}>
                  <AnswerContent>
                    {(item.answer || '').split('\n\n').map((p, j) => <p key={j}>{p}</p>)}
                  </AnswerContent>
                </Answer>
              </Item>
            ))}
          </List>
        </Wrap>
      </Container>
    </Section>
  );
};

export default FAQBlock;
